import { useTheme } from '../context/ThemeContext';

/**
 * Chart colours resolved from the active theme.
 *
 * Recharts writes most of these straight onto SVG presentation attributes,
 * where `var(--token)` is not resolved by browsers — so the values have to be
 * real colours picked in JS rather than CSS custom properties.
 */
export function useChartTheme() {
  const { theme } = useTheme();
  const dark = theme === 'dark';

  return {
    grid: dark ? '#374151' : '#E5E7EB',
    axis: dark ? '#9CA3AF' : '#6B7280',
    line: dark ? '#4FB0DC' : '#0B6FA4',
    bar: '#1F9D57',
    degraded: '#B5771A',
    down: '#D14437',
    tooltip: {
      backgroundColor: dark ? '#1F2937' : '#FFFFFF',
      border: `1px solid ${dark ? '#374151' : '#E5E7EB'}`,
      borderRadius: '6px',
      color: dark ? '#F9FAFB' : '#111827',
      boxShadow: dark ? 'none' : '0 4px 12px rgb(0 0 0 / 0.08)',
    } as const,
  };
}
